console.log("slick-loop");
import $ from "jquery";

class slickSliderLoopNavigazione {
  constructor() {
    this.sliderLoop = $(" .vetrina--offerte .elementor-posts-container");
    this.initCarouselLoop();
  }

  initCarouselLoop() {
    this.sliderLoop.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      speed: 500,
      slidesToScroll: 1,
      adaptiveHeight: false,
      centerPadding: "2em",
      mobileFirst: true,
      //lazyLoad: "ondemand",
      arrows: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            slidesToShow: 1,
            variableWidth: false,
          },
        },
        {
          breakpoint: 639,
          settings: {
            arrows: true,
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            slidesToShow: 3,
            variableWidth: false,
          },
        },
      ],
    });
  }
}
export default slickSliderLoopNavigazione;
